/**
 * Hook para buscar e gerenciar logs de erro do Supabase
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface ErrorLog {
  id: string;
  context: string;
  message: string;
  stack: string | null;
  metadata: any;
  timestamp: string;
  user_id: string | null;
  created_at: string;
}

export function useErrorLogs(limit = 50) {
  return useQuery({
    queryKey: ['error-logs', limit],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('error_logs')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return data as ErrorLog[];
    },
    refetchInterval: 30000 // Refresh a cada 30 segundos
  });
}

export function useChunkErrorStats() {
  return useQuery({
    queryKey: ['chunk-error-stats'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('error_logs')
        .select('context, created_at')
        .ilike('message', '%chunk%')
        .gte('created_at', new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString())
        .order('created_at', { ascending: false });

      if (error) throw error;

      const logs = data as ErrorLog[];
      
      return {
        total: logs.length,
        last24h: logs.length,
        byHour: logs.reduce((acc: Record<string, number>, log) => {
          const hour = new Date(log.created_at).getHours();
          acc[hour] = (acc[hour] || 0) + 1;
          return acc;
        }, {}),
        recentErrors: logs.slice(0, 10)
      };
    },
    refetchInterval: 60000 // Refresh a cada minuto
  });
}
